import { render, staticRenderFns } from "./Commision.vue?vue&type=template&id=1699b88b&scoped=true"
import script from "./Commision.vue?vue&type=script&lang=js"
export * from "./Commision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1699b88b",
  null
  
)

export default component.exports